import useHideTowerLayout from '../../../TowerLayout/hooks/hideTowerLayout';
import MessagePage from '../../../components/Controls/GenericMessagePage/MessagePage';

function NotFound() {
    useHideTowerLayout();
    return (
        <MessagePage
            title="404"
            bigMsg="Looks like something went wrong!"
            smallMsgs={['The page you were looking for is not here.']}
            buttonText="Back to home"
            onButtonClick={() => (window.location.href = '/')}
        />
    );
}
export default NotFound;
